import React, { memo } from 'react';
import {
  Toaster as SonnerToaster,
  ToastClassnames,
  ToasterProps,
} from 'sonner';
import styles from './Toaster.module.scss';
import {
  AlertErrorIcon,
  AlertWarningIcon,
  AlertSuccessIcon,
  AlertInfoIcon,
} from '../SvgIcons';
import { Loader } from 'components/Loader';

export { toast } from 'sonner';

const theme: ToastClassnames = {
  toast: styles.toast,
  success: styles.success,
  warning: styles.warning,
  info: styles.info,
  error: styles.error,
  default: styles.default,
  icon: styles.icon,
};

const options: ToasterProps['toastOptions'] = {
  classNames: theme,
  unstyled: true,
};

const icons: ToasterProps['icons'] = {
  error: <AlertErrorIcon color="#ffffff" />,
  success: <AlertSuccessIcon color="#ffffff" />,
  info: <AlertInfoIcon color="#ffffff" />,
  warning: <AlertWarningIcon color="#ffffff" />,
  loading: (
    <Loader className={styles.loader} isShow={true} smallLoader={true} />
  ),
};

export const Toaster = memo(() => (
  <SonnerToaster position="top-center" icons={icons} toastOptions={options} />
));
